import { createSlice } from '@reduxjs/toolkit';

import { getBimehNamehHadesehEnferadiDetail, printBimehNamehEnferadi } from 'Feature/Hadeseh/Estelam/Actions/action';

import { IEnferadiBimehNamehListState } from './model';

const initialState: IEnferadiBimehNamehListState = {
  loading: false,
  data: null,
};

export const EnferadiBimehNamehDetailSlice = createSlice({
  name: 'Enferadi/BimehNamehDetail',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBimehNamehHadesehEnferadiDetail.pending, (state) => {
        state.loading = true;
        state.data = initialState.data;
      })
      .addCase(getBimehNamehHadesehEnferadiDetail.fulfilled, (state, action) => {
        state.loading = false;

        if (action.payload !== undefined) {
          state.data = action.payload;
        }
        return state;
      })
      .addCase(getBimehNamehHadesehEnferadiDetail.rejected, (state) => {
        state.loading = false;
      });
    builder
      .addCase(printBimehNamehEnferadi.pending, (state) => {
        state.loading = true;
      })
      .addCase(printBimehNamehEnferadi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(printBimehNamehEnferadi.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default EnferadiBimehNamehDetailSlice.reducer;
